import {createEntitySlice} from 'utils/createEntitySlice';
import {PlaceOfService} from 'types/placeOfService';
import {PlaceOfServicesThunks} from 'features/programs/program/services/placeOfServicesThunks';

export interface PlaceOfServiceState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  placeOfServices?: PlaceOfService[];
  pagy?: any;
  placeOfService?: PlaceOfService | null;
  isEditing?: boolean;
}

const initialState: PlaceOfServiceState = {
  status: 'idle',
  error: null,
  placeOfServices: [],
  placeOfService: null,
  pagy: {},
  isEditing: false,
};

const placeOfServicesSlice = createEntitySlice<PlaceOfService>({
  name: 'placeOfService',
  initialState,
  thunks: PlaceOfServicesThunks,
  entityKey: 'placeOfService',
  entitiesKey: 'placeOfServices',
  reducers: {},
});

export const {setEntity: setPlaceOfService, setIsEditing} =
  placeOfServicesSlice.actions;
export {initialState as placeOfServiceInitialState};
export default placeOfServicesSlice.reducer;
